import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  TOKEN_KEY,
  esSesionInvalida,
  handleSessionExpired,
} from "../../shared/utils";

const URL = process.env.REACT_APP_CORE;
const URL_PORTAL = process.env.REACT_APP_API_PORTAL;

// Todas las queries van a backends propios: llevan el token de usuario vigente
// (getUser a ClientCore usuarios/:id iba sin token) y, ante sesion vencida,
// vuelven al login igual que el interceptor de axios.
const rawBaseQuery = fetchBaseQuery({
  prepareHeaders: (headers) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

const baseQueryConSesion = async (args, api, extraOptions) => {
  const result = await rawBaseQuery(args, api, extraOptions);
  if (result.error && esSesionInvalida(result.error.status, result.error.data)) {
    handleSessionExpired();
  }
  return result;
};

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: baseQueryConSesion,
  keepUnusedDataFor: 60,
  tagTypes: ["User", "Credentials", "Wallet"],
  endpoints: (builder) => ({
    getUser: builder.query({
      query: (userId) => ({
        url: `${URL}usuarios/${userId}`,
      }),
      providesTags: ["User"],
    }),
    getCredentials: builder.query({
      query: (userId) => ({
        url: `${URL_PORTAL}clientes?userid=${userId}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenContraPago")}`,
        },
      }),
      providesTags: ["Credentials"],
      transformResponse: (response) => response?.data?.[0] || null,
    }),
    getWallet: builder.query({
      query: (idClient) => ({
        url: `${URL_PORTAL}wallet?idclient=${idClient}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenContraPago")}`,
        },
      }),
      providesTags: ["Wallet"],
      transformResponse: (response) => response?.data?.[0] || null,
    }),
  }),
});

export const {
  useGetUserQuery,
  useGetCredentialsQuery,
  useGetWalletQuery,
  useLazyGetUserQuery,
} = userApi;
